export default __webpack_public_path__ + "static/media/Air Jordan 1 Retro High OG ‘Dark Mocha’.dfd81e47.jpeg";